import { store } from '@/store';

const { VITE_GENESEE_API_HOST } = import.meta.env;

// Invoice List
export async function getInvoiceList() {
  const url = `${VITE_GENESEE_API_HOST}/api/invoice`;
  const { B2BToken } = store.getState().company.tokens;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${B2BToken}`,
        'Content-Type': 'application/json'
      }
    });

    return await response.json();
  } catch (error) {
    // @ts-ignore
    throw error;
  }
}

// Invoice Get PDF 2
export async function getInvoicePdf(url: string) {
  const { B2BToken } = store.getState().company.tokens;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${B2BToken}`,
      }
    });

    return await response.blob();
  } catch (error) {
    // @ts-ignore
    throw error;
  }
}
